var $a88f5311d4c81f62$exports = {};
const $a88f5311d4c81f62$var$bookBtns = document.querySelectorAll('.js-book');
const $a88f5311d4c81f62$var$handleBooking = (e)=>{
    e.preventDefault();
    Calendly.initPopupWidget({
        url: 'https://calendly.com/thewallofbubbly?hide_landing_page_details=1&hide_gdpr_banner=1&background_color=eef3f1&text_color=222222&primary_color=3c6754'
    });
};
$a88f5311d4c81f62$var$bookBtns.forEach((el)=>el.addEventListener('click', $a88f5311d4c81f62$var$handleBooking));


//# sourceMappingURL=index.6e038078.js.map
